import { Component } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { environment } from '../environments/environment';
import { MatomoService } from './users/services/matomo.service';
import { BannerPopupComponent } from './users/banner-popup/banner-popup.component';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent, BannerPopupComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'newFrontend';
  // private recorder: SessionRecorderService 
  constructor(private router: Router,  public matomoService: MatomoService, ) {}

  ngOnInit(): void {
    initFlowbite();
    this.loadGoogleAnalytics();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'GA_TRACKING_ID', { 'page_path': event.urlAfterRedirects });
      }
    });

  }

  loadGoogleAnalytics() {
    const gaId = environment.googleAnalyticsId; // Obtener el ID de Google Analytics del entorno

    if (gaId) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}');
      `;
      document.head.appendChild(script2);
    }
  }
}
